import { render, staticRenderFns } from "./IconLinks.vue?vue&type=template&id=6c5ed7a7&scoped=true"
import script from "./IconLinks.vue?vue&type=script&lang=js"
export * from "./IconLinks.vue?vue&type=script&lang=js"
import style0 from "./IconLinks.vue?vue&type=style&index=0&id=6c5ed7a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ed7a7",
  null
  
)

export default component.exports